export interface Testimonial {
  name: string;
  role: string;
  avatar: string;
  title: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    name: 'Marcus J.',
    role: 'Sneaker Collector',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20man%20with%20stylish%20streetwear%20outfit%2C%20warm%20lighting%2C%20minimalist%20background%2C%20clean%20editorial%20portrait%20photography%20with%20soft%20shadows&width=120&height=120&seq=testimonial-avatar-01&orientation=squarish',
    title: 'Found grails I could not find anywhere else',
    content: 'The CSSBuy spreadsheet saved me hundreds of dollars on sneakers. I found pairs that were sold out everywhere else, and the QC photos helped me verify authenticity before shipping. This directory is a game-changer for any serious collector.',
    rating: 5,
  },
  {
    name: 'Emily R.',
    role: 'Fashion Blogger',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20woman%20with%20fashionable%20outfit%2C%20natural%20light%2C%20clean%20cream%20background%2C%20editorial%20style%20portrait%20with%20soft%20lighting&width=120&height=120&seq=testimonial-avatar-02&orientation=squarish',
    title: 'My go-to resource for budget luxury finds',
    content: 'I have been using this spreadsheet for over a year now. The trusted seller list alone is worth its weight in gold. Every purchase I have made through these links has been exactly as described. Essential for anyone into reps fashion.',
    rating: 5,
  },
  {
    name: 'David K.',
    role: 'Streetwear Enthusiast',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20man%20with%20stylish%20streetwear%2C%20neutral%20expression%2C%20warm%20studio%20lighting%2C%20clean%20minimalist%20portrait%20background&width=120&height=120&seq=testimonial-avatar-03&orientation=squarish',
    title: 'Updated daily — always fresh finds',
    content: 'What sets this spreadsheet apart is how often it gets updated. New finds every single day. The shipping guides alone taught me how to save 40% on international shipping. Cannot recommend this enough for anyone into CSSBuy.',
    rating: 5,
  },
  {
    name: 'Sophie L.',
    role: 'Luxury Shopper',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20woman%20with%20elegant%20style%2C%20warm%20lighting%2C%20soft%20cream%20background%2C%20editorial%20portrait%20photography&width=120&height=120&seq=testimonial-avatar-04&orientation=squarish',
    title: 'Finally a spreadsheet I can actually trust',
    content: 'After getting burned by sketchy sellers on other platforms, I was hesitant. But this spreadsheet only lists verified sellers with real QC photos. My last three hauls were flawless. The comparison tables make choosing so much easier.',
    rating: 5,
  },
  {
    name: 'Alex T.',
    role: 'Reseller & Collector',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20man%20with%20casual%20streetwear%2C%20confident%20expression%2C%20warm%20neutral%20lighting%2C%20clean%20minimalist%20portrait&width=120&height=120&seq=testimonial-avatar-05&orientation=squarish',
    title: 'The QC guides are incredibly detailed',
    content: 'The quality control tutorials in this spreadsheet taught me exactly what to look for in QC photos. Now I can spot flaws from a mile away. The community behind this spreadsheet is also super helpful with legit checks.',
    rating: 5,
  },
  {
    name: 'Jessica M.',
    role: 'First-Time CSSBuy User',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20woman%20smiling%2C%20casual%20style%2C%20natural%20warm%20light%2C%20clean%20cream%20background%2C%20friendly%20editorial%20portrait&width=120&height=120&seq=testimonial-avatar-06&orientation=squarish',
    title: 'Made my first CSSBuy haul so easy',
    content: 'I was totally overwhelmed when I first discovered CSSBuy. This spreadsheet broke everything down step by step. The beginners guide walked me through my entire first order, and now I am hooked. Best resource for newcomers hands down.',
    rating: 5,
  },
];